import { get } from "lodash"
import { Id } from "@turf/helpers"
import { Post, PostData } from "providers/venue/types"
import { getFeatureIDByPath } from "utils/feature"
import { ImdfFeature } from "providers/venue/types"

export const preparePostData = (
  post: Post,
  findOne: (id: Id) => ImdfFeature
): PostData => {
  // Prepare Post
  const { venue_id, category_id } = post.properties
  const venue = findOne(venue_id)
  const category = findOne(category_id)
  const location = get(post, "properties.location")
  const path = location?.url
  const locationType = location?.type
  const featureId = getFeatureIDByPath(path)
  const isReferenceID = locationType === "reference-id"
  const feature = isReferenceID && featureId ? findOne(featureId) : null

  return {
    ...post,
    properties: {
      ...post.properties,
      category,
      feature,
      venue,
    },
  }
}
